var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.download}},[_c('CIcon',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:('Download'),expression:"'Download'"}],attrs:{"name":"cil-cloud-download","placement":"top"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }